import { Outlet } from "react-router-dom";
import { usePageTitle } from "@/lib/usePageTitle";
import { ProductLineProvider } from "@/platform/ProductLineProvider";
import { SupportChatProvider } from "@/components/SupportChatProvider";
import { BrkThemeProvider } from "@/theme/BrkThemeProvider";

// The outermost layout route. It carries no chrome of its own — it exists so the
// route → document.title mapping is owned in exactly one place (BRK-S031),
// wrapping both the marketing shell (AppShell) and the authenticated shell
// (PortalShell) below it. usePageTitle() therefore fires on every client-side
// navigation regardless of which shell renders.
//
// It also hosts the ProductLineProvider so the active platform (Commercial |
// Surety) is a single source shared by the top-bar switcher and the left nav,
// available to every route the shells render — and, inside it, the
// SupportChatProvider (BRK-S136), which needs that platform as the live-chat
// routing key and so must sit below it. The MUI theme (BrkThemeProvider) wraps
// everything, so every route can use MUI components in the brk palette.
export function RootLayout() {
  usePageTitle();
  return (
    <BrkThemeProvider>
      <ProductLineProvider>
        <SupportChatProvider>
          <Outlet />
        </SupportChatProvider>
      </ProductLineProvider>
    </BrkThemeProvider>
  );
}
